<template>
  <div class="app-container">
    <loading
      :can-cancel="false"
      :is-full-page="true"
      :active.sync="isLoggingOut"
      lock-scroll
      loader="spinner"
      color="#0A76EC" >
    </loading>
    <HeaderMenu v-if="checkIfAdmin()" @onLogoutUser="onLogoutUser"/>
    <div class="app-body" :style="appBodyStyle">
      <transition name="fade" mode="out-in">
        <router-view ></router-view>
      </transition>
    </div>
    <!-- <Footer2 /> -->
  </div>
</template>

<script>
import { AuthApi, CompanySettingApi, SystemSettingApi } from '../mixins/api'
import HeaderMenu from './header/HeaderMenu'
import Footer2 from './TheFooter2'
export default {
  mixins: [ AuthApi, CompanySettingApi, SystemSettingApi ],
  components: {
    HeaderMenu,
    Footer2
  },
  data() {
    return {
      isLoggingOut: false
    }
  },
  methods: {
    loadProfile() {
      this.getAuthenticatedUser().then(({ data }) => {
        this.$store.commit('SET_USER', data);
      }).catch((error) => {
        this.$router.push({ path: '/login' });
      })
    },
    loadCompanySetting() {
      const companySettingId = 1;
      this.getCompanySetting(companySettingId).then(({ data }) => {
        this.$store.commit('SET_COMPANY_SETTING', data)
      })
    },
    loadSystemSetting() {
      const systemSettingId = 1;
      this.getSystemSetting(systemSettingId).then(({ data }) => {
        this.$store.commit('SET_SYSTEM_SETTING', data)
      })
    },
    onLogoutUser() {
      this.isLoggingOut = true
      this.revokeAuthentication().then(({ data }) => {
        localStorage.clear()
        setTimeout(() => {
          this.$store.commit('LOGOUT_USER');
          this.$router.replace({ path: '/login' });
          localStorage.clear()
          this.isLoggingOut = false
        }, 1500);
      }).catch(error => {
        const errors = error.response.data.errors
        this.isLoggingOut = false
      })
    },
    checkIfAdmin() {
      return this.$store.state.user && this.$store.state.user.userableType === 'App\\Models\\Personnel'
    }
  },
  created() {
    this.loadProfile();
    this.loadCompanySetting()
    this.loadSystemSetting()
  },
  computed: {
    appBodyStyle() {
      if(this.$route.matched.some(({ name }) => name === 'dashboard')) {
        console.log(this.$route)
        return {
          '--minHeight': 'calc(100vh - 80px)'
        }
      }
      else {
        return {
          '--minHeight': 'calc(100vh - 150px)'
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .app-container {
    width: 100%;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .app-body {
    flex: 1;
    height: 100%;
    width: 100%;
    // padding: 10px 20px;
    min-height: var(--minHeight);
    margin-bottom: 10px;
    position: relative;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.2s ease;
  }


  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

</style>